import * as React from 'react';
import Styled from 'styled-components';

import { Legend } from '../../Typography/Label';
import { Caption } from '../../Typography/Caption';

const Question = Styled.span`
  display: block;
  font-size: 1.6rem;
  line-height: 1.4;
`;

export interface IKBAQuestionProps {
  headline: string;
  blurb: string;
  label: string;
}

export default class KBAQuestion extends React.PureComponent<
  IKBAQuestionProps
> {
  public render () {
    const { headline, blurb, label } = this.props;

    return (
      <>
        <Legend>{label}</Legend>
        <Question>{headline}</Question>
        <Caption>{blurb}</Caption>
      </>
    );
  }
}
